import axios from "axios";
import { ElMessage } from "element-plus";
import router from "@/router"; // 确保引入你的路由实例
import { Cookie } from '@/utils/Cookie'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || "/api",
  // baseURL: 'http://116.204.32.234:8071' || "/api",
  timeout: 60000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = JSON.parse(Cookie.get('token')) || null
    // 如果是登录或公开接口，不添加token
    const isPublicApi = config.url.includes('/login') || config.url.includes('/public');
    if (token && !isPublicApi) {
      config.headers["x-auth-token"] = `${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;

    // 根据你的后端接口设计调整判断条件
    if (res.status !== 200) {
      // 处理token失效的情况
      if (res.status === 401 ||res.status === 405 || res.message === 'Token expired') {
        handleTokenInvalid();
      } else {
        // ElMessage.error(res.message || "请求失败");
      }
      return Promise.reject(new Error(res.message || "Error"));
    }
    return res;
  },
  (error) => {
    // 处理HTTP错误状态码
    if (error.response) {
      switch (error.response.status) {
        case 401: // 未授权
          handleTokenInvalid();
          break;
        case 403: // 禁止访问
          ElMessage.error("拒绝访问");
          break;
        case 404: // 资源不存在
          ElMessage.error("请求资源不存在");
          break;
        case 500: // 服务器错误
          ElMessage.error("服务器错误");
          break;
        default:
          ElMessage.error(error.response.data?.message || "请求出错");
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      ElMessage.error("网络错误，请检查网络连接");
    } else {
      // 其他错误
      ElMessage.error(error.message || "未知错误");
    }

    return Promise.reject(error);
  }
);

// 处理token失效的统一方法
function handleTokenInvalid() {
      // Cookie.remove("userInfo");
      // Cookie.remove("token");
       Cookie.remove("checkIP_login");
  // 清除本地存储的token
  // localStorage.removeItem("token");

  // 显示提示信息
  // ElMessage.warning("登录已过期，请重新登录");

  // 跳转到登录页
  // router.push("/login").catch(() => { });

  // 可以在这里添加清理其他用户数据的逻辑
  // clearUserData();
}

export default service;